import { Button, QRCode, message } from "antd";
import axios from "axios"
import { useRef } from "react";
import { useState } from "react";
import { useEffect } from "react";
import { url, client_id, token_url } from './setting'

const BindLineId = ({
    userId,
    onSuccess = () => { }
}) => {
    const [date_now] = useState(Date.now())
    const [bind, setBind] = useState(false);
    const user_id = userId ? { user_id: userId } : {}
    const getQrcodeBind = () => {
        axios
            .get('/qrcode/bind', {
                params: {
                    ...user_id
                }
            })
            .then(response => {
                if ((response.data?.data||[]).find(_=>true)?.line_user_id) {
                    line_login_ref.current = false
                    setBind(true);
                } else {
                    setBind(false);
                    patch_line_bind()
                }
            })
    }
    useEffect(() => {
        getQrcodeBind()
        return () => {
            line_login_ref.current = false
        }
    }, [])
    const line_login_ref = useRef(true);
    const patch_line_bind = () => {
        axios
            .get('/system/user_per', {
                params:{
                    ...user_id
                }
            })
            .then(response => {
                if ((response.data?.data||[]).find(_=>true)?.line_user_id) {
                    line_login_ref.current = false
                    message.success('綁定完成')
                    setBind(true)
                    onSuccess()
                }
            })
            .finally(() => {
                if (line_login_ref.current)
                    setTimeout(() => patch_line_bind(), 1000)
            })
    }
    const resetLineUserId = ()=>{
        
        axios
            .post('/qrcode/bind/reset',{
                ...user_id
            })
            .then(response => {
                getQrcodeBind()
            })
    }
    return (<>
        {bind && <>已完成綁定</>}
        {bind && <Button onClick={() => {
            resetLineUserId()
        }}>重新綁定</Button>}
        {!bind && <>請掃描以下QRcode進行綁定</>}
        {!bind && <QRCode
            value={`https://access.line.me/oauth2/v2.1/authorize?response_type=code&client_id=${client_id}&redirect_uri=${url}&state=` +
                encodeURI(JSON.stringify({
                    state:date_now,
                    service:'/organization_structure/home',
                    ...user_id
                })) +
                '&scope=profile%20openid&nonce=' + date_now}
        />}
    </>)
}
export default BindLineId;